export const CARRERAS = 5;
export const ESTADO = 1; // Activo
export const PREGUNTA_ENCUESTA_REGISTRO_ACOMPANAMIENTO = 311; // local 3004  produccion 311
export const RESPUESTA_ENCUESTA_REGISTRO_ACOMPANAMIENTO = 312;  // local 3005 produccion 312
export const RESPUESTA_OTROS = 32937;  // local 6384 produccion 32937 
export const TIPO_ACOMPANAMIENTO_DOCENTE = 313; // local 3006  produccion 313
export const ESTADO_ACOMPANAMIENTO_DOCENTE = 314; //local 3003 produccion 314
export const PREGUNTA_GRUPO_PRIORIZADO = 32930; // local 6373 produccion 32930
export const RESPUESTA_GRUPO_PRIORIZADO = 32941; // local 6374 produccion 32941 
export const PREGUNTA_TIPO_CASO = 32933; // local 6376 produccion 32933 
export const RESPUESTA_NINGUNO = 33484; // local 7392 produccion 33484